import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'
import {httpGetAccesses, HttpGetAccessesOptions, HttpGetAccessesResponse} from '@/features/accesses/http/accesses.http'
import {z} from 'zod'

type PromiseArgs = {params: Omit<HttpGetAccessesOptions['params'], 'page' | 'limit'>} & {limit: number}

export const useGetInfiniteAccesses = (
    promiseArgs: PromiseArgs,
    options?: Pick<UseInfiniteQueryOptions<z.infer<typeof HttpGetAccessesResponse>>, 'enabled'>
) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.ACCESSES, promiseArgs.params],
        queryFn: ({pageParam = 1}) =>
            httpGetAccesses({
                params: {
                    page: pageParam,
                    limit: promiseArgs.limit,
                    ...promiseArgs.params
                }
            }),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    }
}
